export enum ShipmentStatus {
  NEW = "new",
  DISPATCHED = "dispatched",
  COMPLETE = "complete",
  CANCELLED = "cancelled",
  ERROR = "error",
}
